import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { httpStatusCode, routePaths, errorMessages } from '@constants/index';
import { SessionService, NotificationService, LoadingService } from '@core/services';
import { Router } from '@angular/router';

@Injectable( {
  providedIn: 'root'
} )
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
    private readonly notifyService: NotificationService,
    private readonly loaderService: LoadingService
  ) { }

  intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    return next.handle( req ).pipe( tap( () => { },
      ( err: any ) => {
        if ( err instanceof HttpErrorResponse ) {
          if ([httpStatusCode.unAuthorize, httpStatusCode.unAuthenticate].indexOf(err.status) !== -1) {
            this.unAuthorizedHandler();
          }
          this.loaderService.hideLoadingScreen();
          const message = err.message || err.statusText;
          return throwError(message);
        }
      } ) );
  }

  private unAuthorizedHandler(): void {
    this.sessionService.clearAllCookies();
    this.notifyService.showError( errorMessages.unauthorizeToken, errorMessages.type );
    this.router.navigate( [ routePaths.login ] );
  }
}
